import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/Icons';
import { themeIconTypes } from '@/components/OtherMenu';
import { Radio } from '@/components/Radio';
import type { Theme } from '@/types/theme';
import { tv } from '@/utils/tv';

const option = tv({
  base: 'flex min-h-[54px] w-full cursor-pointer items-center gap-3 rounded-xl border p-4 text-left transition-colors',
  variants: {
    isSelected: {
      true: 'border-primary bg-info-surface text-primary',
      false:
        'border-on-primary-surface bg-on-primary-surface text-muted-foreground',
    },
  },
});

interface Props {
  theme: Theme;
  isSelected: boolean;
  onSelect: (theme: Theme) => void;
}

export const ThemeOption: React.FC<Props> = ({
  theme,
  isSelected,
  onSelect,
}) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={() => onSelect(theme)}
      className={option({ isSelected })}
    >
      <Icon icon={themeIconTypes[theme]} className="size-6 shrink-0" />
      <span className="flex-1 text-subhead-14">
        {t(`sidebar.theme.${theme}`)}
      </span>
      <Radio checked={isSelected} />
    </button>
  );
};
